/**
 * BambooPacks header — scroll-blended theme + glass nav
 */
class BambooHeader {
  constructor() {
    this.wrapper = document.querySelector('.bamboo-header-wrapper');
    this.hero = document.querySelector('.bamboo-hero');
    if (!this.wrapper) return;

    this.isIndex = document.body.classList.contains('template-index');
    this.theme = this.isIndex ? 0 : 1;

    this.onScroll = this.onScroll.bind(this);
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
  }

  onScroll() {
    const headerHeight = this.wrapper.offsetHeight || 72;

    if (this.isIndex && this.hero) {
      const heroBottom = this.hero.getBoundingClientRect().bottom;
      const fadeStart = headerHeight + 140;
      const fadeEnd = headerHeight - 20;
      const range = fadeStart - fadeEnd;
      this.theme = range > 0
        ? Math.max(0, Math.min(1, (fadeStart - heroBottom) / range))
        : heroBottom > headerHeight ? 0 : 1;
    } else {
      this.theme = 1;
    }

    this.wrapper.style.setProperty('--nav-theme', this.theme.toFixed(3));
    this.wrapper.classList.toggle('is-over-hero', this.theme < 0.55);
    this.wrapper.classList.toggle('is-past-hero', this.theme >= 0.55);
    this.wrapper.classList.toggle('is-scrolled', window.scrollY > 8);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BambooHeader();
});
